import { BASE_URL } from "../constants"

export const RESULT_TYPES = {
  PIN: 1,
  OWNER_NAME: 2,
  ADDRESS: 3,
}

export const SEARCH_RESULT_SYMBOLS = {
  [RESULT_TYPES.PIN]: {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [ 35,35,35, 0.9 ],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: [ 0,193, 240, 0.9 ],
      width: 1
    }
  },
  [RESULT_TYPES.OWNER_NAME]: {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [ 35,35, 35, 0.9 ],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: [ 0,193, 240, 0.9 ],
      width: 1
    }
  },
  [RESULT_TYPES.ADDRESS]: {
    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
    url: `${BASE_URL}images/position-icon.png`,
    width: "40px",
    height: "40px"
  },
  selected: {
    [RESULT_TYPES.PIN]: {
      type: "simple-fill",  // autocasts as new SimpleFillSymbol()
      color: [ 0,193, 240, 0.9 ],
      style: "solid",
      outline: {  // autocasts as new SimpleLineSymbol()
        color: "white",
        width: 1
      }
    },
    [RESULT_TYPES.OWNER_NAME]: {
      type: "simple-fill",  // autocasts as new SimpleFillSymbol()
      color: [ 0,193, 240, 0.9 ],
      style: "solid",
      outline: {  // autocasts as new SimpleLineSymbol()
        color: "white",
        width: 1
      }
    },
    [RESULT_TYPES.ADDRESS]: {
      type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
      url: `${BASE_URL}images/position-active-icon.png`,
      width: "40px",
      height: "40px"
    }
  }
}